var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAlertDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_alert_delete",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_5",
    "data-name": "\\uC0AC\\uAC01\\uD615 5",
    width: 24,
    height: 24,
    fill: "rgba(255,0,0,0.1)",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_133",
    "data-name": "\\uADF8\\uB8F9 133",
    transform: "translate(11 8.252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_134",
    "data-name": "\\uADF8\\uB8F9 134",
    transform: "translate(-3.5 -0.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_7",
    "data-name": "\\uD569\\uCE58\\uAE30 7",
    d: "M7.845,8.8,4.5,5.456,1.154,8.8A.676.676,0,0,1,.2,7.845L3.544,4.5.2,1.154A.676.676,0,0,1,1.154.2L4.5,3.544,7.845.2a.676.676,0,0,1,.957.956L5.456,4.5,8.8,7.845a.676.676,0,0,1-.956.957Z",
    transform: "translate(0 0)",
    fill: "#e9397a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertDelete);
export default __webpack_public_path__ + "static/media/icon_alert_delete.24f3a10ef911c93dbb5ddca38626f03a.svg";
export { ForwardRef as ReactComponent };